const routes = [
    {
        path: "/coop/student",
        component: () => import("../pages/Student"),
        meta: {
            isAuthenticated: true,
            isStudent: true
        }
    },
    {
        path: "/coop/student/postings/:id",
        component: () => import("../pages/PostingDetail"),
        meta: {
            isAuthenticated: true,
            isStudent: true
        }
    }
];

export default routes;
